import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface Period {
  id: string;
  start_date: string;
  end_date: string;
  period_type: 'monthly' | 'annual';
  is_closed: boolean;
}

export const usePeriods = () => {
  const { user, loading: authLoading } = useAuth();
  
  return useQuery({
    queryKey: ['periods', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('financial_periods')
        .select('*')
        .order('start_date', { ascending: false });

      if (error) throw error;
      return (data || []) as Period[];
    },
    enabled: !authLoading && !!user,
    staleTime: 60000,
    refetchOnWindowFocus: false,
  });
};
